import { toStreamID, toUserId } from '@streamr/utils';
import { z } from 'zod';
import { KeyStore } from '../../engine/helpers/KeyStore';
import { safeRetrieve, safeStore } from '../../utils/storage';
import { formFullStreamId } from '../../utils/streamId';
import { ScheduledSessionSchema, } from './ScheduledSession';
const SCHEDULED_SESSIONS_LOCALSTORAGE_KEY = 'scheduledSessions';
export class ScheduledSessionStore {
    scheduledSessions = [];
    constructor() {
        const sessionsFromLocalStorage = safeRetrieve(SCHEDULED_SESSIONS_LOCALSTORAGE_KEY, 
        // biome-ignore lint/suspicious/noExplicitAny: TODO remove type when we remove the temporary migration
        (raw) => {
            const migrated = raw.map((item) => {
                const migratedItem = item;
                // temporary migration for legacy "publicKey" property name, TODO remove within few months
                if (item.publicKey !== undefined) {
                    migratedItem.broadcasterUserId = toUserId(`0x${item.publicKey}`);
                    delete migratedItem.publicKey;
                }
                // migration to fill in broadcasterPrivateKey from KeyStore if missing
                if (item.broadcasterPrivateKey === undefined) {
                    migratedItem.broadcasterPrivateKey =
                        KeyStore.getInstance().getPrivateKey(toStreamID(item.streamId));
                }
                // migration for stream IDs to full form
                migratedItem.streamId = formFullStreamId(migratedItem.streamId);
                return migratedItem;
            });
            const parsed = z
                .array(ScheduledSessionSchema)
                .safeParse(migrated);
            return parsed.success
                ? parsed.data
                : [];
        });
        const sessions = Array.isArray(sessionsFromLocalStorage)
            ? sessionsFromLocalStorage
            : [];
        if (sessions.length > 0) {
            this.setScheduledSessionsSorted(sessions);
        }
    }
    getScheduledSessions() {
        return this.scheduledSessions;
    }
    addScheduledSession(session) {
        this.setScheduledSessionsSorted([...this.scheduledSessions, session]);
    }
    deleteScheduledSession(id) {
        this.setScheduledSessionsSorted(this.scheduledSessions.filter((s) => s.id !== id));
    }
    updateScheduledSession(scheduledSession) {
        this.setScheduledSessionsSorted(this.scheduledSessions.map((s) => s.id === scheduledSession.id ? scheduledSession : s));
    }
    setScheduledSessionsSorted(sessions) {
        this.scheduledSessions = [...sessions].sort((a, b) => a.startsAt - b.startsAt);
        safeStore(SCHEDULED_SESSIONS_LOCALSTORAGE_KEY, this.scheduledSessions);
    }
    clearScheduledSessions() {
        this.scheduledSessions = [];
        safeStore(SCHEDULED_SESSIONS_LOCALSTORAGE_KEY, undefined);
    }
}
